module.exports = __webpack_public_path__ + "img/user_ChengXin.1022ed2a.png";